module.exports = __webpack_public_path__ + "static/media/icon-replies.054583f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-replies.svg
// module id = 1997
// module chunks = 0